<!-- Start::menu item (lg+) -->
<div class="hidden lg:block">
  @if(country=='pe'){
  <h2 class="fw-bold ps-3" style="font-size: 14px">Holding EPYSA PERÚ</h2>
  } @else{
  <h2 class="fw-bold ps-3" style="font-size: 14px">Holding EPYSA CHILE</h2>
  }
  <hr class="my-2" style="background-color: #646462" />

  <div>
    <ul>
      <li class="ps-3" *ngFor="let link of links">
        <a [href]="link.link">{{ link.label }}</a>
      </li>
    </ul>
  </div>
</div>
<!-- End::menu item (lg+) -->

<!-- Start::menu item (xs, sm y md) -->
<div class="block lg:hidden">
  <div
    class="col-12 py-0"
    data-bs-toggle="collapse"
    data-bs-target="#holding"
    [attr.aria-expanded]="terminos"
    aria-controls="holding"
  >
    <div class="row">
      <div class="col-8 py-0 flex justify-content-start">
        @if(country=='pe'){
        <h3 class="fw-bold text-start">Holding EPYSA PERÚ</h3>
        } @else{
        <h3 class="fw-bold text-start">Holding EPYSA CHILE</h3>
        }
      </div>
      <div class="col-4 py-0 flex justify-content-end">
        <i class="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  </div>
  <hr class="my-2" style="background-color: #646462" />

  <div
    class="collapse multi-collapse"
    [ngClass]="terminos ? 'show' : ''"
    id="holding"
  >
    <ul>
      <li class="ps-3" *ngFor="let link of links">
        <a [href]="link.link">{{ link.label }}</a>
      </li>
    </ul>
    <hr class="my-2" style="background-color: #646462" />
  </div>
</div>
<!-- End::menu item (xs, sm y md) -->
